import { Color } from "../enums/Color";

export const preferredPartnersPage = {
    mobile: {
        text: {
            margin: "2vh 5% 0vh",
            fontFamily: "Poppins",
            fontSize: "1.8vh"
        },
        container: {
            margin: "10vh 5%",
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            justifyItems: "center" as "center",
            rowGap: "5vh"
        },
        wrapper: {
            overflow: "hidden"
        }, 
        logoWrapper: {
            margin: "8vh 0 12vh 0"
        },
        detailWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
        },

        logo: {
            height: "10vh",
            width: "100%",
            objectFit: "scale-down",
            cursor: "pointer"
        },
        partnerName: {
            textAlign: "center" as "center",
            color: Color.DarkGray,
            fontFamily: "Poppins",
            fontSize: "3.98vw",
            fontWeight: 500,
            margin: "2vw auto 0 auto",
            maxWidth: "60vw",
        }, 
    },
    desktop: {
        text: {
            display: "none"
        },
        detailWrapper: {
            alignItems: "center",
        },
        logo: { 
            height: "4vw",           
            maxWidth: "20vw"
        },
        partnerName: {
            fontSize: "0.89vw",
            maxWidth: "16vw",
            marginTop: "1vw",
            color: Color.DarkGray
        }     
    }
}